/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { useTranslation } from 'react-i18next';

export type VisitStatus = 'pending' | 'confirmed' | 'done' | 'cancelled';

export const VISIT_ACCENT_COLORS: Record<VisitStatus, string> = {
  pending:   '#8B6914',
  confirmed: '#3D5A47',
  done:      '#2D5A6B',
  cancelled: '#7A3B1E',
};

const STATUS_KEYS: Record<VisitStatus, string> = {
  pending:   'statuses.pending',
  confirmed: 'statuses.confirmed',
  done:      'statuses.done',
  cancelled: 'statuses.cancelled',
};

/**
 * Resolves the localized label for each visit status.
 *
 * @returns A map from visit status to its translated label.
 */
export function useVisitStatusLabels(): Record<VisitStatus, string> {
  const { t } = useTranslation('features/visits');
  return Object.fromEntries(
    Object.entries(STATUS_KEYS).map(([k, v]) => [k, t(v)]),
  ) as Record<VisitStatus, string>;
}
